<template>
  <div class="cab-orderby">
    <select name="cab-orderby" id="cab-orderby" v-model="orderBy">
      <option value="menu_order">{{ this.$i18n.orderDefault }}</option>
      <option value="date">{{ this.$i18n.orderLatest }}</option>
      <option value="popularity">{{ this.$i18n.orderPopularity }}</option>
      <option value="price">{{ this.$i18n.orderPriceASD }}</option>
      <option value="price-desc">{{ this.$i18n.orderPriceDESC }}</option>
      <option value="power">{{ this.$i18n.orderPowerASD }}</option>
      <option value="power-desc">{{ this.$i18n.orderPowerDESC }}</option>
    </select>
  </div>
</template>

<script>
export default {
  computed: {
    orderBy: {
      get() {
        return this.$store.getters.orderBy;
      },
      set(value) {
        return this.$store.dispatch("setOrderBy", value);
      },
    },
  },
  watch: {
    orderBy(value) {
      let query = Object.assign({}, this.$route.query);

      if (value) {
        query.orderby = value;

        this.$router
          .push({
            name: "Catalog",
            query,
          })
          .catch((err) => {});
      } else {
        delete query.orderby;

        this.$router
          .replace({
            name: "Catalog",
            query,
          })
          .catch((err) => {});
      }
    },
  },
  created() {
    if (this.$route.query.orderby) {
      this.orderBy = this.$route.query.orderby;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Order.vue